module.exports = __webpack_public_path__ + "img/tool01.b76b06bf.png";